<script>

export default {
    setup() {
        const { t } = useI18n();
        const auth = useAuthStore();
        const layout = useLayoutStore();
        const helpers = useHelperStore();
        const storage = useResponseStore();
        const version = useVersionStore();
        const module = useModuleStore();
        return { auth, layout, helpers, storage, version, t, module }
    },
    mounted() {
        let lang = 'id';
        if (this.storage.getStorage('locale')) {
            lang = this.storage.getStorage('locale');
            this.setLocale(lang);
        } else {
            this.setLocale(lang);
        }
    },
    computed: {
        appVer() {
            if (this.version.version) return this.version.version.version;
            return null;
        }
    },
    methods: {
        async endSession() {
            await this.$swal({
                title: this.t('End This Session?'),
                icon: 'warning',
                showCancelButton: true,

            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.auth.logout();
                    this.$router.replace('/auths/login');
                }
            });
        },
        setLocale(payload) {
            this.$i18n.locale = payload;
            this.storage.setStorage('locale', payload);
            if (document.getElementById('dropdown-lang'))
                UIKit.dropdown('#dropdown-lang').hide(false);
        },
    },
};
</script>

<template>
    <div class="navigation-top uk-background-default">
        <div class="uk-navbar-container uk-navbar-transparent" uk-navbar="mode: click">
            <div class="uk-navbar-left">
                <ul class="uk-navbar-nav ids-navbar-left">
                    <li>
                        <div @click="$router.replace('/')" class="logo uk-flex pointer">
                            <img src="/images/logo-dark.png" alt="Logo" />
                        </div>
                    </li>
                    <li style="padding-top: 5px;">
                        <span class="uk-dark uk-text-small brand uk-visible@s">
                            <b>{{ layout.appName }}</b>
                            <br /><small>Ver. {{ appVer }}</small>
                        </span>
                    </li>
                </ul>
            </div>
            <div class="uk-navbar-right">
                <ul class="uk-navbar-nav" style="gap: 0px;">
                    <li v-if="module.check('company')">
                        <CompanySelector />
                    </li>
                    <li>
                        <DashboardsNotification />
                    </li>
                    <li v-if="auth.user">
                        <button class="uk-button uk-button-small uk-button-default uk-padding-remove">
                            <span class="uk-dark uk-text-small uk-margin-small-right uk-text-capitalize uk-visible@s">
                                {{ auth.user.name }}
                            </span>
                            <img v-if="auth.user.profilePicture" class="initial-name bg-color-x"
                                :src="auth.user.profilePicture" :alt="auth.user.name" />
                            <span v-else class="initial-name bg-color-x">
                                {{ auth.user.nameInitial }}
                            </span>
                        </button>
                        <div uk-dropdown="mode: click;" class="uk-width-small">
                            <template v-if="auth.user.profilePicture">
                                <img class="profile-picture" :alt="auth.user.name" :src="auth.user.profilePicture" />
                                <hr class="uk-margin-small-bottom uk-margin-small-top" />
                            </template>
                            <template v-if="auth.roles">
                                <div class="uk-width-1-1 uk-flex uk-flex-center">
                                    <div v-for="val in auth.roles" :key="val" class="uk-badge uk-text-capitalize">
                                        {{ val }}
                                    </div>
                                </div>
                                <hr class="uk-margin-remove-bottom uk-margin-small-top" />
                            </template>
                            <ul class="uk-nav uk-dropdown-nav">
                                <li>
                                    <RouterLink to="/dashboard/settings/profile" class="uk-padding-remove-vertical">
                                        <span class="navigation-side-icon material-icons md-20">
                                            <EditIcon />
                                        </span>
                                        <span class="navigation-side-label">{{ $t('Profile') }}</span>
                                    </RouterLink>
                                </li>
                                <li class="uk-nav-divider"></li>
                                <li>
                                    <button @click="endSession"
                                        class="uk-margin-auto-vertical	uk-button uk-button-primary red uk-width-1-1">
                                        <span class="navigation-side-icon material-icons md-20">
                                            <LogoutIcon />
                                        </span>
                                        <span class="navigation-side-label">{{ $t('Logout') }}</span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </li>

                    <li v-if="auth.user && $i18n.availableLocales.length > 0">
                        <button
                            class="uk-button uk-button-small uk-button-default uk-padding-remove uk-flex uk-flex-middle">
                            <div class="initial-name bg-color-x">
                                <LanguageIcon size="20" />
                            </div>
                        </button>
                        <div id="dropdown-lang" uk-dropdown="mode: click;">
                            <button v-for="locale, key in $i18n.availableLocales" @click="setLocale(locale)"
                                v-bind:key="key"
                                class="uk-margin-auto-vertical uk-button uk-button-default uk-text-left uk-width-1-1 uk-flex uk-flex-middle"
                                :class="locale === $i18n.locale ? 'uk-text-bold' : ''">
                                <span class="navigation-side-label">
                                    {{ locale.toUpperCase() }} - {{ helpers.getLocaleName(locale) }}
                                </span>
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <FormModalChangePassword />
</template>


<style scoped>
.ids-navbar-left {
    gap: 0px;
    align-items: center;
}

.profile-picture {
    width: 150px;
    height: 150px;
    border-radius: 100px;
}
</style>
